'use client';

import React from 'react';

const MainLayout = ({ children }: { children: React.ReactElement }) => {
  return <>{children}</>;
};

export default MainLayout;
